// export { default } from "./ModalVacanciesFilter"

import React from "react"
import { createRoot } from "react-dom/client"
import { computeFilterValues } from "scripts/components/vacancies-page"
import ModalVacanciesFilter from "./ModalVacanciesFilter"

const renderModalVacanciesFilter = () => {
  const body = document.querySelector("body")
  let cartContainer = document.querySelector(".js_modal_certificate_order_root")

  const { vacancyCategories, vacancyCities } = computeFilterValues()

  if (!cartContainer) {
    cartContainer = document.createElement("div")
    cartContainer.classList.add("js_modal_certificate_order_root")

    // root && render(<ModalVacanciesFilter />, root);
    body.appendChild(cartContainer)
  }

  if (cartContainer) {
    const root = createRoot(cartContainer)
    root.render(
      <ModalVacanciesFilter
        vacancyFilterCategoryList={vacancyCategories}
        vacancyFilterCityList={vacancyCities}
      />,
    )
  }
}
export default renderModalVacanciesFilter
